import styled from '@emotion/styled';
import { Drawer, SwipeableDrawer } from '@mui/material';

const SHEET_RADIUS = '20px';

const paperBase = {
  borderTopLeftRadius: SHEET_RADIUS,
  borderTopRightRadius: SHEET_RADIUS,
  fontFamily: 'var(--font-Pretendard)',
};

export const StyledSwipeableDrawer = styled(SwipeableDrawer)({
  '& .MuiDrawer-paper': paperBase,
});

// swipeable={false} 경로. Approval·MonitoringSales 계열이 스와이프로 닫히면 안 되는
// 시트라 비-스와이프 MUI Drawer 로 렌더한다.
export const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': paperBase,
});

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  width: 100%;
  flex-shrink: 0;
`;

export const DrawerHandle = styled.div`
  width: 40px;
  height: 4px;
  background-color: var(--dk-bg-strong, #d1d8e2);
  border-radius: 2px;
`;

export const DrawerContent = styled.div`
  overflow-y: auto;
`;

export const HeaderTitleLayout = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 14px 16px 14px 20px;
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  min-height: 57px;
  flex-shrink: 0;
`;

export const StyledTitle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
`;

export const DrawerFooter = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom, 0px);
`;
